module.exports = __webpack_public_path__ + "static/media/Otamendi.5432bcd5.png";